<template>
  <div id="navs" class="font no-print">
    <header class="py-3 nav-dd">
      <!-- 左-圖片超連 -->
      <div class="col-sm ml-2">
        <a href="https://www.nuk.edu.tw/" title="回高大">
          <img
            class="nav-img float-left"
            src="../../assets/logoword_2.png"
            alt="回高大"
          />
        </a>
      </div>
      <!-- 中-標題 -->
      <div class="col-sm ml-2">
        <a
          class="nav-size word-bold"
          style="text-decoration: none;"
          href="#/admin/login"
        >
          <v-font v-if="Testsystem === true" font-text="測試環境-" />
          多元繳費系統-後台
        </a>
      </div>
      <!-- 右-登入狀態-帳號資訊 -->
      <div class="col-sm text-right">
        <div v-if="!UserData">
          未登入
        </div>
        <div v-else-if="UserData">
          {{ UserData.UserName }} ({{ UserData.UserId }})
          <div>
            {{ UserData.Privilege }}:
            <v-font :font-text="UserData.UserManyDep" />
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  name: 'navs',
  data () {
    return {
      UserData: JSON.parse(sessionStorage.getItem('UserData'))
        ? JSON.parse(sessionStorage.getItem('UserData'))
        : null,
      CheckBackendPrivilege: '',
      CheckPrivilege: '',
      index: false,
      Testsystem: window.g.Testsystem
    }
  },
  created () {
    const vm = this
    // 接收登入資訊
    vm.$bus.$on('LoginUser', data => {
      vm.LoginUser(data)
    })
    // 接收登出資訊
    vm.$bus.$on('LogOutUser', () => {
      vm.LogOutUser()
    })
  },
  methods: {
    LoginUser (data) {
      // 判斷登入變換資訊
      const vm = this
      vm.UserData = JSON.parse(sessionStorage.getItem('UserData'))
      vm.index = data
      const BackendPrivilege = sessionStorage.getItem('BackendPrivilege')
      const Backend = sessionStorage.getItem('Backend')
      vm.CheckBackendPrivilege = md5('有權限')
      vm.CheckPrivilege = md5('管理者')
      if (vm.CheckBackendPrivilege === BackendPrivilege) {
        vm.index = true
        if (vm.CheckPrivilege === Backend) {
          vm.Privilege = '管理者：'
        } else {
          vm.Privilege = '業務單位：'
        }
      }
    },
    LogOutUser () {
      this.index = false
      this.UserData = false
    }
  }
}
</script>
